import { keepPreviousData, useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { MetaType, Order } from "types/OrdersTypes";

export default function useGetOrders(page: number) {
  return useQuery({
    queryKey: ["data"],
    queryFn: async () => {
      return axiosInstance.get(`/data?page=${page}`).then((res) => res.data);
    },
    placeholderData: keepPreviousData,
    select: (data: { data: { data: Order[]; meta: MetaType } }) => ({
      data: data.data.data,
      meta: data.data.meta,
    }),
    retry: false,
  });
}
